"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultimediaElement = void 0;
const react_1 = __importStar(require("react"));
const util_1 = require("./util");
const handlers = [
    {
        type: "img",
        condition: /^image\//,
    },
    {
        type: (props) => (react_1.default.createElement("video", Object.assign({}, props, { controls: true }))),
        condition: /^video\//,
    },
];
const MultimediaElement = (props) => {
    const { src, mimeType } = props;
    const ElementType = (0, react_1.useMemo)(() => {
        var _a;
        return typeof mimeType === "string"
            ? (_a = handlers.find((handler) => handler.condition.test(mimeType))) === null || _a === void 0 ? void 0 : _a.type
            : undefined;
    }, [mimeType]);
    console.log({ src, mimeType, ElementType });
    if (!ElementType) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const copiedProps = (0, util_1.removeKey)(props, "mimeType");
    return react_1.default.createElement(ElementType, Object.assign({}, copiedProps, { src: src }));
};
exports.MultimediaElement = MultimediaElement;
